/**
 * Settings → Check for Updates.
 *
 * Asking the service worker alone wasn't enough: it activates a new version on its own
 * (skipWaiting), so after a dismissed "Reload now?" the worker was already new while the
 * page still ran the old code - and every later check said "up to date". index.html is
 * precached, so a plain reload served the old page too; only Ctrl+Shift+R got past it.
 *
 * So compare the bundle this page is running with the one the server has now. If they
 * differ, do what Ctrl+Shift+R does: drop the service worker and reload from the network
 * (index.js registers a fresh worker on the way back). Runtime caches (TBA lists) stay.
 */

/** The main bundle an HTML page loads ("/static/js/main.ab50e78a.js"), or null. */
export function mainBundle(html) {
    const m = String(html ?? '').match(/src="([^"]*\/static\/js\/main\.[^"]+\.js)"/);
    return m ? m[1] : null;
}

function runningBundle() {
    const s = document.querySelector('script[src*="/static/js/main."]');
    return s ? new URL(s.src, window.location.href).pathname : null;
}

/**
 * @returns {Promise<'updating'|'current'|'unknown'>} unknown = couldn't reach the server or read either bundle
 */
export async function checkForAppUpdate() {
    const regs = navigator.serviceWorker ? await navigator.serviceWorker.getRegistrations() : [];
    await Promise.all(regs.map(r => r.update().catch(() => undefined)));

    let deployed = null;
    try {
        // The query keeps it out of the precache, so this comes from the network.
        const res = await fetch(`/?update-check=${Date.now()}`, { cache: 'no-store' });
        if (res.ok) deployed = mainBundle(await res.text());
    } catch {
        return 'unknown';
    }
    const running = runningBundle();
    if (!deployed || !running) return 'unknown';
    if (deployed === running) return 'current';

    await Promise.all(regs.map(r => r.unregister().catch(() => undefined)));
    window.location.reload();
    return 'updating';
}
